export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "TSMR",
    question: "Double Solid Yellow Lane means that",
    options: [
      "Overtaking and changing lanes is not allowed",
      "Overtaking is allowed but changing lane is not",
      "Changing lane is allowed but overtaking is not",
    ],
    correctAnswer: "Overtaking and changing lanes is not allowed",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
];
